class EventEmitter {

  constructor() {

    this.registrations = [];

  }

  setMaxListeners() {}

  on(eventName, handler) {

    this.registrations.push({ eventName, handler });

  }

  emit(eventName, ...parameters) {

    const registrations = this.registrations;

    for (let registration of registrations) {

      if (registration.eventName !== eventName) {
        continue;
      }

      try {

        registration.handler(...parameters);

        // eslint-disable-next-line no-empty
      } catch (exception) {}

    }

  }

  off(eventName, handler) {

    const registrations = this.registrations;

    let index = -1;

    for (let registration of registrations) {

      if (registration.eventName !== eventName) {
        continue;
      }

      if (registration.handler !== handler) {
        continue;
      }

      index = this.registrations.indexOf(registration);

    }

    if (index === -1) {
      return;
    }

    this.registrations.splice(index, 1);

  }

}

class InternalEventEmitter extends EventEmitter {

  constructor() {

    super();

    this.instanceRegistrations = new WeakMap();

  }

  eventFor(module, eventName, handler) {

    if (this.instanceRegistrations.has(module) === false) {
      this.instanceRegistrations.set(module, []);
    }

    const registrations = this.instanceRegistrations.get(module);

    registrations.push({ eventName, handler });

    this.on(eventName, handler);

  }

  offAllOn(module) {

    if (this.instanceRegistrations.has(module) === false) {
      this.instanceRegistrations.set(module, []);
    }

    const registrations = this.instanceRegistrations.get(module);

    for (let registration of registrations) {
      this.off(registration.eventName, registration.handler);
    }

    this.instanceRegistrations.delete(module);

  }

}

export default InternalEventEmitter;